// ** React Imports
import { useMemo } from "react";

// ** Redux & Store & Actions
import { useSelector } from "react-redux";

// ** Third Party Components
import { useTranslation } from "react-i18next";

// ** Custom Components
import { ButtonLanding } from "components/layout/Button/ButtonLanding";

// #####################################################

const NextButton = ({ text, isModal, ...props }) => {
	const { t } = useTranslation(["common", "landing"]);

	const language = useSelector((state) => state.globalCommon.language);

	const nextButtonText = useMemo(() => {
		if (text) {
			return text;
		}
		return t("landing:register.next");
	}, [language, text]);

	// ** A/B Tests
	const authModalVersion = useSelector(
		(state) => state.globalCommon.authModal.version
	);
	// #####################################################

	return (
		<ButtonLanding
			$isModal={isModal}
			$authModalVersion={authModalVersion}
			{...props}
		>
			{nextButtonText}
		</ButtonLanding>
	);
};

// #####################################################

export default NextButton;

// #####################################################
